import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Returns true only when ids_token is a non-empty, non-placeholder string.
 * Guards against localStorage storing the literal strings "null" or "undefined".
 */
function isTokenValid(raw) {
  if (!raw) return false;
  const trimmed = raw.trim();
  return trimmed.length > 0 && trimmed !== 'null' && trimmed !== 'undefined';
}

/**
 * V2PrivateRoute — Auth guard for HashRouter apps.
 * - Returns null immediately (no children rendered) when not authenticated.
 * - Uses useNavigate inside useEffect (post-render) so HashRouter's internal
 *   state updates correctly without a render-phase race condition.
 *
 * @param {{ children: React.ReactNode }} props
 */
function V2PrivateRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const rawToken = localStorage.getItem('ids_token');
  const isAuthenticated = isTokenValid(rawToken);

  useEffect(() => {
    if (!isAuthenticated) {
      const attemptedPath = `${location.pathname}${location.search}${location.hash}`;
      navigate(`/login?redirect=${encodeURIComponent(attemptedPath)}`, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  if (!isAuthenticated) {
    return null;
  }

  return children;
}

export default V2PrivateRoute;
